import { useDispatch, useSelector } from "react-redux";
import {
  selectAuth,
  selectUserRoles,
} from "../../SharedModule/redux/reducers/auth.reducer";
import { TelerikReport } from "../../SharedModule/components/TelerikReport";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { useEffect } from "react";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  ROUTE_TIMESHEETS_REPORTS,
  TIME_SUPER_ADMIN_ACCESS,
} from "../../SharedModule/utils/constants";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";

export const BambooTimeOffReportPage = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  // to help telerik reports to get correct local timezone
  const today = new Date();
  const importDate = new Date(
    Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    )
  );
  let parameters = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken,
    StartDate: importDate,
    EndDate: importDate,
  };

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  useEffect(() => {
    document.title = "The Hub - BambooHR Time Off Report";
    dispatch(setActiveTab(ROUTE_TIMESHEETS_REPORTS));
  }, []);

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, TIME_SUPER_ADMIN_ACCESS, userRolesList) && (
          <ForbiddenPage />
        )}
      {rolesLoaded &&
        verifyModuleAccess(true, TIME_SUPER_ADMIN_ACCESS, userRolesList) && (
          <TelerikReport
            title="BambooHR time off export"
            reportName="BambooTimeOffExport.trdp"
            parameters={parameters}
            parametersAreaVisible={true}
            backButtonText="Back to Time Reports"
            backButtonRoute={ROUTE_TIMESHEETS_REPORTS}
          />
        )}
    </>
  );
};
